export const UpravljanjeKorisnicimaResourcesEN: UpravljanjeKorisnicimaResourcesBSInterface =
  {
    dupplicateError: "Addition failed, entered data is duplicated",
    upravljanjeKorisnicima: {
      title: "User management",
      dropdownLabel: "Select user:",
      dropdownPlaceholder: "Select user from list",
      dropdownNoOptionsMessage: "No data",
      addCompanyButton: "Add user",
      next: "Select",
      back: "Back",
    },
    UKPPK: {
      title: "User Management User Data Verification",
      addCompanyButton: "Add company",
      addUserPosition: "Add workplace",
      addRecord: "Add evidence",
      branch: "Branch: ",
      address: "Address: ",
      position: "Workplace: ",
    },
    branchManagement: {
      currentBranches: "Current branches for",
      noBranchesAssigned: "No branches assigned to this user.",
      availableBranches: "Available branches",
      addBranch: "Add branch",
      hide: "Hide",
      remove: "Remove",
      add: "Add",
      noAvailableBranches: "No available branches to add.",
      loading: "Loading...",
      error: "Error:",
    },
    menuAccessRights: {
      title: "Menu access rights for",
      saveButton: "Save changes",
      description:
        "Select the screens the user can see in the menu. You can add or remove items for each category.",
      selectPlaceholder: "Select screens...",
      noOptions: "No options available",
      updateError: "Error updating access rights.",
    },
    managerChief: {
      titleManager: "Manager in branches",
      titleChief: "Chief in companies",
      noManagers: "User is not assigned as manager to any branch.",
      noChiefs: "User is not assigned as chief to any company.",
    },
    contractedHours: {
      title: "Contracted working hours",
      label: "Weekly hours",
      hint: "Default is 40 hours per week. In the timesheet, exceedance is shown when a worker goes over this in a calendar week (Mon–Sun).",
      save: "Save",
      saving: "Saving...",
      saved: "Contracted hours saved.",
      error: "Error saving contracted hours.",
      invalid: "Enter a valid number of hours (1–168).",
      noPermission:
        "Only managers, chiefs or admins can change contracted hours.",
    },
  };

export interface UpravljanjeKorisnicimaResourcesBSInterface {
  dupplicateError: string;
  upravljanjeKorisnicima: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    next: string;
    back: string;
  };
  UKPPK: {
    title: string;
    addCompanyButton: string;
    addUserPosition: string;
    addRecord: string;
    branch: string;
    address: string;
    position: string;
  };
  branchManagement: {
    currentBranches: string;
    noBranchesAssigned: string;
    availableBranches: string;
    addBranch: string;
    hide: string;
    remove: string;
    add: string;
    noAvailableBranches: string;
    loading: string;
    error: string;
  };
  menuAccessRights: {
    title: string;
    saveButton: string;
    description: string;
    selectPlaceholder: string;
    noOptions: string;
    updateError: string;
  };
  managerChief: {
    titleManager: string;
    titleChief: string;
    noManagers: string;
    noChiefs: string;
  };
  contractedHours: {
    title: string;
    label: string;
    hint: string;
    save: string;
    saving: string;
    saved: string;
    error: string;
    invalid: string;
    noPermission: string;
  };
}
